import React from 'react';

import { useFormContext } from 'react-hook-form';

import {
  ERROR_FIELD_CLASS,
  IBlockItemFormProps
} from 'views/Pages/PagesForm/constants';
import { pageFormSchema } from 'views/Pages/PagesForm/validation-schema';
import { z } from 'zod';

import Checkbox from 'components/Checkbox/Checkbox';
import { cn } from 'components/lib/utils';

import {
  FormControl,
  FormField,
  FormItem,
  FormMessage
} from '../../../../../../../components/ui/form';
import { Input } from '../../../../../../../components/ui/input';

export const VideoItemForm: React.FC<IBlockItemFormProps> = ({
  item,
  blockIndex,
  itemIndex
}) => {
  const { control, getFieldState, trigger } =
    useFormContext<z.infer<typeof pageFormSchema>>();

  const basePath = `blocksV2.${blockIndex}.items.${itemIndex}` as const;

  const getFieldError = (fieldName: string) => {
    const fieldState = getFieldState(fieldName as any);
    return fieldState.error;
  };

  return (
    <>
      <FormField
        control={control}
        name={`${basePath}.url`}
        render={({ field: { onChange, value } }) => (
          <FormItem>
            <FormControl>
              <Input
                title="Video URL"
                placeholder="Add a video URL to your page"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const url = e.target.value;
                  onChange(url);
                  trigger('blocksV2');
                }}
                value={value ?? undefined}
                className={cn(
                  'w-full',
                  getFieldError(`${basePath}.url`)?.message
                    ? ERROR_FIELD_CLASS
                    : ''
                )}
                required
                data-testid="PagesForm-Upload-Video"
              />
            </FormControl>
            <FormMessage className="mt-1 text-p-s text-base-destructive" />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={`${basePath}.mobileUrl`}
        render={({ field: { onChange, value } }) => (
          <FormItem>
            <FormControl>
              <Input
                title="Mobile Video URL"
                placeholder="Add a mobile video URL to your page"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const url = e.target.value;
                  onChange(url);
                  trigger('blocksV2');
                }}
                value={value ?? undefined}
                className={cn(
                  'w-full',
                  getFieldError(`${basePath}.mobileUrl`)?.message
                    ? ERROR_FIELD_CLASS
                    : ''
                )}
                required
                data-testid="PagesForm-Upload-MobileVideo"
              />
            </FormControl>
            <FormMessage className="mt-1 text-p-s text-base-destructive" />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={`${basePath}.autoplay`}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                label={'Autoplay'}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
